<template>
  <div class="page-content" style="padding-top: 2.5rem">
    <div class="container-fluid">
      <div class="row" style="margin-top: 2rem">
        <div class="col-xxl-12">
          <div class="d-flex flex-column h-100">
            <div class="row">
              <div class="col-md-9" style="text-align: left">
                <h5><strong>&nbsp;&nbsp;&nbsp;Booking Overview</strong></h5>
              </div>
              <div class="col-md-12"><br /></div>
              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Total Bookings
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="28.05">
                              {{ bookingMetrics?.total_bookings || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-ticket-2-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Cancelations
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ bookingMetrics?.cancelled_bookings || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-close-circle-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Completed Bookings
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ bookingMetrics?.completed_bookings || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-bookmark-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">Revenue</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ bookingMetrics?.total_revenue || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-line-chart-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-4">
                <div class="card">
                  <div class="card-header border-0 align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">Booking Summery</h4>
                  </div>
                  <div class="card-body">
                    <apexchart
                      type="donut"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                    <br />
                    <div class="row g-0 text-center">
                      <div class="col-6 col-sm-6">
                        <div class="p-3 border border-dashed border-start-0">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="9851">{{
                              bookingMetrics?.total_bookings || 0
                            }}</span>
                          </h5>
                          <p class="text-muted mb-0">Total Bookings</p>
                        </div>
                      </div>
                      <div class="col-6 col-sm-6">
                        <div class="p-3 border border-dashed border-start-0">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="9851">{{
                              bookingMetrics?.completed_bookings || 0
                            }}</span>
                          </h5>
                          <p class="text-muted mb-0">Completed Bookings</p>
                        </div>
                      </div>
                      <div class="col-6 col-sm-6">
                        <div class="p-3 border border-dashed border-start-0">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="9851">{{
                              bookingMetrics?.cancelled_bookings || 0
                            }}</span>
                          </h5>
                          <p class="text-muted mb-0">Cancelled Bookings</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card">
                  <div class="card-header border-0 align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">Revenue Trends</h4>
                  </div>

                  <div class="card-body p-0 pb-2">
                    <div>
                      <apexchart
                        type="bar"
                        :options="revenueChartOptions"
                        :series="revenueSeries"
                      >
                      </apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
                class="col-md-12"
                style="text-align: center; padding: 10px; color: #000"
              > -->
              <!-- <h5><strong>Searches Overview</strong></h5>
              </div>
              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Total Searches
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-search-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->

              <!-- <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Successful Bookings
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-ticket-2-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Conversion Rates
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-file-user-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/bookings">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Missing Bookings
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              0
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-coupon-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div> -->
              <div
                class="col-md-12"
                style="text-align: center; padding: 10px; color: #000"
              >
                <h5><strong>Customer Overview</strong></h5>
              </div>
              <div class="col-md-3">
                <a href="/users">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Total Customers
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ customerMetrics?.total_customers || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-user-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/users">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            New Customers
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ customerMetrics?.new_customers || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-user-follow-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/users">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Monthly Active
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ customerMetrics?.monthly_active_users || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-group-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/users">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Avg. Ticket Value
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ customerMetrics?.average_ticket_value || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-price-tag-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="col-md-12"
                style="text-align: center; padding: 10px; color: #000"
              >
                <h5><strong>Vehicle Partner Overview</strong></h5>
              </div>
              <div class="col-md-3">
                <a href="#products">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Total Partners Live
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ operatorMetrics?.active_partners || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-account-box-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            New Partners
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ operatorMetrics?.new_partners || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-account-circle-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Activation Pending Partners
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ operatorMetrics?.pending_partners || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-account-pin-circle-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Daily Active Partners
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ operatorMetrics?.daily_active_operators || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-account-pin-box-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div
                class="col-md-12"
                style="text-align: center; padding: 10px; color: #000"
              >
                <h5><strong>Bus Overview</strong></h5>
              </div>
              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">Total Buses</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ busMetrics?.active_buses || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-bus-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">New Buses</p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ busMetrics?.new_buses || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-bus-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Pending Buses
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ busMetrics?.pending_buses || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-bus-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-3">
                <a href="/buses">
                  <div class="card card-animate">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="fw-semibold text-muted mb-0">
                            Total Active Cities
                          </p>
                          <h2 class="mt-4 ff-secondary fw-bold">
                            <span class="counter-value" data-target="97.66">
                              {{ busMetrics?.total_active_cities || 0 }}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div class="avatar-sm flex-shrink-0">
                            <span
                              class="avatar-title bg-soft-info rounded-circle fs-2"
                              style="color: #29badb"
                            >
                              <i class="ri-user-2-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <!-- <div
                class="col-md-7 mb-3"
                style="text-align: right; display: flex"
              >
                <div class="search-box mx-2" style="width: 60%">
                  <input
                    type="date"
                    v-model="from_date"
                    class="form-control search"
                  />
                </div>
                <div class="search-box" style="width: 60%">
                  <input
                    type="date"
                    v-model="to_date"
                    class="form-control search"
                  />
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-success add-btn"
                  @click="handleFetch"
                >
                  Search
                </button>
              </div> -->
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header border-0 align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">
                      Top Performing Buses
                    </h4>
                  </div>

                  <div class="card-body p-0 pb-2">
                    <div>
                      <apexchart
                        type="bar"
                        :options="busChartOptions"
                        :series="busSeries"
                      >
                      </apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header border-0 align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">
                      Top Performing Users
                    </h4>
                  </div>

                  <div class="card-body p-0 pb-2">
                    <div>
                      <apexchart
                        type="bar"
                        :options="chartOptions2"
                        :series="series2"
                      >
                      </apexchart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoaderLoading v-if="loaderLoading" />
    </div>
  </div>
</template>

<script>
import { getHomeData } from "@/apis/admin";

export default {
  name: "AppHome",
  data() {
    return {
      loaderLoading: false,
      bookingMetrics: {},
      customerMetrics: {},
      operatorMetrics: {},
      busMetrics: {},

      series: [],
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: ["Total", "Completed", "Cancelled"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      series2: [
        {
          name: "Total Spent",
          data: [],
        },
      ],
      chartOptions2: {
        chart: {
          type: "bar",
          height: 350,
        },
        xaxis: {
          categories: [],
        },
      },

      busSeries: [
        {
          name: "Total Earnings",
          data: [],
        },
      ],
      busChartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      revenueSeries: [],
      revenueChartOptions: {
        chart: {
          type: "area",
          height: 350,
        },
        stroke: {
          curve: "smooth",
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#000"],
          },
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },

  created() {
    this.handleFetch();
  },

  methods: {
    setTopUsers(data) {
      const users = data.top_performing_users || [];
      this.series2 = [
        {
          name: "Total Bookings",
          data: users.map((user) => user.total_bookings),
        },
      ];

      this.chartOptions2 = {
        ...this.chartOptions2,
        xaxis: {
          categories: users.map((user) => user.customer_name),
        },
      };
    },
    setTopBuses(data) {
      const buses = data?.top_performing_buses || [];
      this.busSeries = [
        {
          name: "Total Bookings",
          data: buses.map((bus) => bus.total_bookings || 0),
        },
      ];

      this.busChartOptions = {
        ...this.busChartOptions,
        xaxis: {
          categories: buses.map((bus) => bus.bus_number || "Bus"),
        },
      };
    },
    setRevenueTrends(data) {
      const trends = data?.revenue_trends || [];

      this.revenueSeries = [
        {
          name: "Revenue",
          data: trends.map((i) => i.revenue || 0),
        },
        {
          name: "Bookings",
          data: trends.map((i) => i.paid_bookings || 0),
        },
      ];

      this.revenueChartOptions = {
        ...this.revenueChartOptions,
        xaxis: {
          categories: trends.map((i) => i.date),
        },
      };
    },
    async handleFetch() {
      this.loaderLoading = true;
      const filters = {
        from_date: this.from_date,
        to_date: this.to_date,
      };

      const data = await getHomeData(filters);
      if (data?.status) {
        const {
          bookingMetrics,
          customerMetrics,
          operatorMetrics,
          busMetrics,
          graphData,
          bookingRevenueTrends,
        } = data?.data;
        if (bookingMetrics) {
          this.bookingMetrics = bookingMetrics;
          this.series = [
            bookingMetrics?.total_bookings,
            bookingMetrics?.completed_bookings,
            bookingMetrics?.cancelled_bookings,
          ];
        }

        if (bookingRevenueTrends?.revenue_trends) {
          this.setRevenueTrends(bookingRevenueTrends);
        }

        if (customerMetrics) {
          this.customerMetrics = customerMetrics;
        }
        if (operatorMetrics) {
          this.operatorMetrics = operatorMetrics;
        }
        if (busMetrics) {
          this.busMetrics = busMetrics;
        }
        if (graphData?.top_performing_users) {
          this.setTopUsers(graphData);
        }
        if (graphData?.top_performing_buses) {
          this.setTopBuses(graphData);
        }
      }
      this.loaderLoading = false;
    },
  },
};
</script>
